module.exports = __webpack_public_path__ + "img/中评反馈图片.0cb86146.png";